import apiClient from './api';
import {
  Publication,
  CreatePublicationRequest,
  UpdatePublicationRequest,
} from '../types';

export const publicationService = {
  // 모든 공포·공시 조회
  async getAllPublications(): Promise<Publication[]> {
    const response = await apiClient.get<Publication[]>('/publications');
    return response.data;
  },

  // 특정 공포·공시 조회
  async getPublication(publicationId: string): Promise<Publication> {
    const response = await apiClient.get<Publication>(`/publications/${publicationId}`);
    return response.data;
  },

  // 공포·공시 생성
  async createPublication(publicationData: CreatePublicationRequest): Promise<Publication> {
    const response = await apiClient.post<Publication>('/publications', publicationData);
    return response.data;
  },

  // 공포·공시 수정
  async updatePublication(publicationId: string, publicationData: UpdatePublicationRequest): Promise<Publication> {
    const response = await apiClient.patch<Publication>(`/publications/${publicationId}`, publicationData);
    return response.data;
  },

  // 공포·공시 삭제
  async deletePublication(publicationId: string): Promise<void> {
    await apiClient.delete(`/publications/${publicationId}`);
  },

  // 공포·공시 승인
  async approvePublication(publicationId: string): Promise<Publication> {
    const response = await apiClient.post<Publication>(`/publications/${publicationId}/approve`);
    return response.data;
  },

  // 공포·공시 승인 취소
  async unapprovePublication(publicationId: string): Promise<Publication> {
    const response = await apiClient.post<Publication>(`/publications/${publicationId}/unapprove`);
    return response.data;
  },

  // 최근 공포·공시 조회
  async getRecentPublications(limit: number = 3): Promise<Publication[]> {
    const response = await apiClient.get<Publication[]>(`/publications?limit=${limit}&sortBy=createdAt&sortOrder=desc`);
    return response.data;
  },
}; 